import React, { useEffect, useState } from 'react';
import { fetchShotSyncStation } from '../../../services/api';
import { useTranslation } from '../../../context/LanguageContext';
import './ShotSyncNew.css';

/* 비전검사·융합검사 상단의 데이터 출처 안내 한 줄.
 * 설비의 샷동기화 스테이션이 데모 공정이거나 데모 카메라면 "데모"임을 밝힌다 (데모 값을 실측처럼 보이지 않게).
 * 스테이션이 없거나 모두 실데이터면 아무것도 그리지 않는다. */
function SyncSourceNote({ equipmentId }) {
  const { t } = useTranslation();
  const [station, setStation] = useState(null);

  useEffect(() => {
    let alive = true;
    setStation(null);
    if (!equipmentId) return undefined;
    fetchShotSyncStation(equipmentId)
      .then((res) => { if (alive) setStation(res || null); })
      .catch(() => { if (alive) setStation(null); });
    return () => { alive = false; };
  }, [equipmentId]);

  if (!station || !station.enabled) return null;
  const parts = [];
  if (station.demoProcess) parts.push('process');
  if (station.imageSource === 'DEMO') parts.push('camera');
  if (station.demoProcess || station.imageSource === 'DEMO') parts.push('verdict');
  if (parts.length === 0) return null;

  const tr = (key, params) => t(`pages.monitoring.machine.shotSync.${key}`, params);
  return (
    <div className="ss-source-note">
      <span className="material-symbols-outlined">info</span>
      {tr('sourceNote', { items: parts.map((p) => tr(`sourceItems.${p}`)).join(' · ') })}
    </div>
  );
}

export default SyncSourceNote;
